export default function booleanToText(bool) {
  return bool ? "Sim" : "-";
}
